import { lazy } from "react";

export const CustomResultView = lazy(() => import("./CustomResultView.jsx"));
export const CustomHelmet = lazy(() => import("./CustomHelmet.jsx"));
export const CustomSortView = lazy(() => import("./CustomSortView.jsx"));
// export const EntityTootlip = lazy(() => import("./EntityTootlip.jsx"));
// export const KeywordComponent = lazy(() => import("./KeywordComponent.jsx"));
export const SimilarDocuments = lazy(() => import("./SimilarDocuments.jsx"));
export const RangeSlider = lazy(() => import("./RangeSlider.jsx"));
export const Layout = lazy(() => import("./Layout.jsx"));
export const Loading = lazy(() => import("./Loading.jsx"));
export const Empty = lazy(() => import("./Empty.jsx"));
export const Error = lazy(() => import("./Error.jsx"));
export const NavBar = lazy(() => import("./NavBar.jsx"));
export const HighLightControllers = lazy(() => import("./HighLightControllers.jsx"));
export const EditDocument = lazy(() => import("./EditDocument.jsx"));
export const DocumentEntity = lazy(() => import("./DocumentEntity.jsx"));
export const TabsComponent = lazy(() => import("./TabsComponent.jsx"));
export const TextEditor = lazy(() => import("./TextEditor.jsx"));
// export const EntityEditor = lazy(() => import("./EntityEditor.jsx"));
export const InputAutoComplete = lazy(() => import("./InputAutoComplete.jsx"));
export const Table = lazy(() => import("./Table.jsx"));
export const AttachedDocs = lazy(() => import("./AttachedDocs.jsx"));
export const TopQueries = lazy(() => import("./TopQueries.jsx"));
export const KpiCard = lazy(() => import("./KpiCard.jsx"));
export const PieChart = lazy(() => import("./PieChart.jsx"));
export const LineChart = lazy(() => import("./LineChart.jsx"));
// export const HomePageMetaData = lazy(() => import("./HomePageMetaData.jsx"));
export const HomePageLoading = lazy(() => import("./HomePageLoading.jsx"));
export const FacetLoading = lazy(() => import("./FacetLoading.jsx"));